export class CertificateResultDto {
    title: string;
    helpKey: string;

    // Transient Fields
    helpLink: string;
}
